import style from './styles/CardVideoChannel.module.css';

import { ICardVideoChannelProps } from '../../interface/interface';

// Order imports
// Styles
// Native and other dependences
// Actions Redux
// Actions Controllers and constants
// Components
// Interfaces

const CardVideoChannel: React.FC<ICardVideoChannelProps> = (props) => {


    return (
        <div key={props.videoId} className={style.middleCardImage}
            style={{
                backgroundImage: `url(${props.image})`
            }}>
           

                <div className={style.middleCardTop}>
                    <p className={style.videoDescription}><strong>{props.title}</strong></p>
                    <p style={{ display: "none" }}>{props.description}</p>
                    <p style={{ display: "none" }}>Id del canal: {props.channelId}</p>
                </div>

                <div className={style.middleCardButtons}>
                    <button onClick={() => props.addVideoList()}
                        className={style.middleCardButtons}>Add</button>
                    <button onClick={() => props.getUrlVideo(props.videoId, props.channelTitle)}
                        className={style.middleCardButtons}>Play</button>
                    <button onClick={() => props.goBack("videos")}
                        className={style.middleCardButtons}>Back</button>
                </div>
        
        </div>
    )
}

export default CardVideoChannel;
